import React from "react";
import { bind } from "decko";
import NumericInput from 'react-numeric-input';
import DialogOverlay from "./DialogOverlay";
import GenericBlackBtn from "./GenericBlackBtn";

export default class StreamOptionsDialog extends React.Component {

    @bind
    onClickLiveMode () {
        const {options, onChangeOptions} = this.props;

        //Make a copy
        let newOptions = {...options};
        newOptions.liveTagging = !newOptions.liveTagging;
        onChangeOptions(newOptions);
    }

    @bind
    onLiveDelayChange (value) {
        const {options, onChangeOptions} = this.props;

        //Make a copy
        let newOptions = {...options};
        newOptions.extraLiveDelay = value;
        onChangeOptions(newOptions);
    }

    render () {
        const {game, onDone, options} = this.props;

        const {liveTagging, extraLiveDelay} = options;

        return (
            <DialogOverlay
                hotkeyHandler={this.props.hotkeyHandler}
                onSubmit={onDone}
            >
                <div className="row" style={{marginBottom: "16px"}}>
                    <div className="col-xs-12 text-center">
                        Stream Options: {game.home_team.name} v {game.visiting_team.name}
                    </div>
                    <div className="col-xs-12 text-outline" style={{marginTop: "10px"}}>
                        <div className="row">
                            <div className="col-xs-8 options-label">
                                Live Tagging Mode
                                <br/>
                                <span>Use <b>system</b> clock, absolute time. Not stream clock. Used when working with an external source with lower latency.</span>
                                <br/>
                                <span>Ignores seeking. Option ignored on VODs.</span>
                            </div>
                            <div className="col-xs-4">
                                <GenericBlackBtn
                                    style={{width: "65px", float: "right"}}
                                    btnClassName="fullwidth"
                                    onClick={this.onClickLiveMode}>
                                    {liveTagging ? "ON" : "OFF"}
                                </GenericBlackBtn>
                            </div>
                        </div>
                        {liveTagging && (
                            <div className="row" style={{marginTop: "10px"}}>
                                <div className="col-xs-8 options-label">
                                    Added Live Latency (seconds)
                                    <br/>
                                    <span>Only active with live tagging mode. If external source has a predictable delay, set this here.</span>
                                </div>
                                <div className="col-xs-4 text-right">
                                    <NumericInput
                                        value={extraLiveDelay}
                                        onChange={this.onLiveDelayChange}
                                        min={0}
                                        max={300}
                                        step={0.5}
                                        precision={1}
                                        snap
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </DialogOverlay>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/StreamOptionsDialog.js